import { ActorContext } from '@planitgeo/treeplotter-domain/lib/modules/identity-and-access/common/domain/actor-context';

/**
 * Who a command runs as on the device. Nothing reads it: the device decides nothing, and the
 * server re-checks every command at sync, as the signed-in person (Tech PRD §9).
 */
export const DEVICE_ACTOR_CONTEXT: ActorContext = {
  actor: { type: 'unmapped', kind: 'mobile-device' },
};
